<template>
    <section id="page-quotes" class="page-quotes page">
        <div class="page__content">
            <div class="container">
                <div class="row">
                    <div class="col-12-sm">
                        <!-- Profile incomplete -->
                        <div v-if="!showQuotes">
                            <h1>Ervaringen van docenten</h1>
                            <p>Je hebt hierboven nog niet aangegeven wat je huidige situatie is en hoe je hybride zou willen werken.
                                Zodra je dit hebt gedaan kun je op deze pagina over ervaringen lezen van hybride docenten die in een vergelijkbare situatie werken.</p>
                        </div>
                        <!-- Profile complete -->
                        <div v-else>
                            <h1>HIERONDER LEES JE HOE HYBRIDE DOCENTEN DIE VOOR EEN VERGELIJKBARE CONSTRUCTIE ALS DIE VAN JOU HEBBEN GEKOZEN HUN HYBRIDE WERK ERVAREN.</h1>
                            <div class="page-quotes__categories">
                                <!-- Categories -->
                                <div class="page-quotes__categories-item"
                                     v-for="category in quoteCategories"
                                     v-on:click="selectCategory(category)"
                                     v-bind:class="{'page-quotes__categories-item--active': category === currentCategory}"
                                >{{category}}</div>
                            </div>
                            <!-- Quotes -->
                            <div>
                                <paged-quotes :quotes="currentQuotes"></paged-quotes>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <page-next-button v-on:click="nextHandler"></page-next-button>
        </div>
    </section>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";

    .page-quotes__categories-item
        display inline-block
        padding .5em
        height @width
        font-family $font-button
        cursor pointer
        border 1px solid $color-main-1
        border-right none
        &:last-child
            border-right 1px solid $color-main-1

    .page-quotes__categories-item--active
        background-color $color-main-1
        color #ffffff
</style>
<script>
    const ScrollMagic = require('ScrollMagic');
    const TimelineMax = require('TimelineMax');

    import page from './page';
    import pagedQuotes from '../paged-quotes/paged-quotes.vue';


    export default {
        mixins: [page],
        props: {
            quotes: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                quoteCategories: [],
                currentCategory: null,
                filteredQuotes: []
            }
        },
        computed: {
            showQuotes() {
                return this.userProfile.baan1 && this.userProfile.baan2;
            },
            currentQuotes() {
                let quotes = [];
                if (this.userProfile.baan1 && this.userProfile.baan2) {
                    const rol = this.userProfile.baan1.category || this.userProfile.baan2.category;
                    quotes = this.quotes.filter(quote => quote.rol === rol && quote.categorie === this.currentCategory);
                }
                return quotes;
            }
        },
        created() {
            this.quoteCategories = _.uniqBy(this.quotes, 'categorie').map(quote => quote.categorie);
            this.selectCategory(_.first(this.quoteCategories));
        },
        methods: {
            selectCategory(category) {
                this.currentCategory = category;
            }
        },
        components: {
            pagedQuotes
        }
    }

</script>



// WEBPACK FOOTER //
// page-quotes.vue?52529245